import React from 'react';
import { AnnouncementBar } from '../components/sections/AnnouncementBar';
import { HeroSection } from '../components/sections/HeroSection';
import { PainPoints } from '../components/sections/PainPoints';
import { Benefits } from '../components/sections/Benefits';
import { ThisIsForYou } from '../components/sections/ThisIsForYou';
import { MeetSara } from '../components/sections/MeetSara';
import { Transformation } from '../components/sections/Transformation';
import { ProductPresentation } from '../components/sections/ProductPresentation';
import { Bonuses } from '../components/sections/Bonuses';
import { Testimonials } from '../components/sections/Testimonials';
import { PlatformTrustBar } from '../components/sections/PlatformTrustBar';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { StickyMobileCTA } from '../components/sections/StickyMobileCTA';
import { SectionDivider } from '../components/ui/SectionDivider';
export function LandingPage() {
  return <div className="min-h-screen bg-dark text-cream font-lato overflow-x-hidden relative" data-id="element-437">
      <AnnouncementBar data-id="element-438" />

      <main data-id="element-439">
        <HeroSection data-id="element-440" />
        <SectionDivider data-id="element-441" />

        <PainPoints data-id="element-442" />
        <SectionDivider data-id="element-443" />

        <Benefits data-id="element-444" />
        <SectionDivider data-id="element-445" />

        <ThisIsForYou data-id="element-446" />
        <SectionDivider data-id="element-447" />

        <MeetSara data-id="element-448" />
        <SectionDivider data-id="element-449" />

        <Transformation data-id="element-450" />
        <SectionDivider data-id="element-451" />

        <ProductPresentation data-id="element-452" />
        <SectionDivider data-id="element-453" />

        <Testimonials data-id="element-454" />
        <SectionDivider data-id="element-455" />

        <PlatformTrustBar data-id="element-456" />
        <SectionDivider data-id="element-457" />

        <Bonuses data-id="element-458" />
        <SectionDivider data-id="element-459" />

        <FAQ data-id="element-460" />
        <SectionDivider data-id="element-461" />

        <FinalCTA data-id="element-462" />
      </main>

      <Footer data-id="element-463" />

      <StickyMobileCTA data-id="element-464" />
    </div>;
}